import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent, useState } from 'react';

interface PaidIconProps {
    paid: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: 28
        },
        tooltipContainer: {
            zIndex: 10,
            padding: '8px 13px',
            position: 'absolute',
            pointerEvents: 'none',
            backgroundColor: '#fff',
            border: '1px solid #000',
            borderRadius: 8,
            top: -40,
            left: -10
        },
        tooltipText: {
            color: '#000',
            fontSize: 14,
            lineHeight: '16px'
        }
    })
);

export const PaidIcon: FunctionComponent<PaidIconProps> = props => {
    const classes = useStyles();

    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <Box
            className={classes.container}
            onMouseLeave={() => setShowTooltip(false)}
            onMouseEnter={() => setShowTooltip(true)}
        >
            {props.paid && showTooltip && (
                <Box className={classes.tooltipContainer}>
                    <Typography className={classes.tooltipText}>Paid</Typography>
                </Box>
            )}
            {props.paid && (
                <FontAwesomeIcon
                    icon={faCircleCheck}
                    color="#5E8677"
                    fontSize={18}
                />
            )}
        </Box>
    );
};

export default PaidIcon;
